import { Map } from 'immutable';
import actions from './actions';

const initState = Map<string, any>({
  modalVisible: false,
  jobId: null,
  applicationId: null,
  feedbackModalVisible: false,
});

export default function interviewQuestionsReducer(state = initState, action: any) {
  switch (action.type) {
    case actions.TOGGLE_QUESTIONS_MODAL:
      const { visible, projectId, jobId, applicationId, candidateName } = action.payload;
      if (visible && jobId && applicationId) {
        return state
          .set('modalVisible', true)
          .set('jobId', jobId)
          .set('applicationId', applicationId);
      }
      if (visible === false) {
        return state.set('modalVisible', false);
      }
      return state;
    case actions.TOGGLE_FEEDBACK_MODAL:
      return state.set('feedbackModalVisible', action.payload);
    default:
      return state;
  }
}
